export const MODULO_LABELS = {
    DOCUMENTACION: 'Documentación',
    INFORME_AVANCE: 'Informe de Avance',
    CONTROL_CAMBIO: 'Control de Cambios',
    ENCUESTA_SATISFACCION: 'Encuesta de Satisfacción',
    GENERAL: 'Solicitud General',
};

export const getModuloLabel = (moduloTipo) => MODULO_LABELS[moduloTipo] || moduloTipo || 'General';

export const getSnapshotResumen = (snapshot) => {
    if (!snapshot) return null;
    const valor = snapshot.titulo
        || snapshot.nombre_cambio
        || snapshot.nombre
        || snapshot.nombre_documento
        || snapshot.nombre_persona;
    if (valor) return String(valor);
    if (snapshot.id) return `Elemento #${snapshot.id}`;
    return null;
};